module.exports = __webpack_public_path__ + "img/12.1913aa4a.jpg";